import React from 'react';
import {useTranslation} from 'react-i18next';

import {InfoDropdown} from '@edna/components';
import VisibilityOffIcon from '@edna/icons/visibilityOff.svg';

import {showNeverViewPromptModal} from './NeverViewPromptModal';
import * as S from './style';

type TProps = {
  className?: string;
  onHide: TEmptyFunction;
  iconSize?: string;
  iconColor?: TThemeColor;
  promptTitle: string;
  promptSubtitle: string;
};

export const NeverViewButton = React.memo<TProps>(
  ({className, onHide, promptSubtitle, promptTitle, iconSize = '16px', iconColor = 'grey400'}) => {
    const {t} = useTranslation();

    return (
      <InfoDropdown
        className={className}
        head={
          <S.HoveredIcon
            size={iconSize}
            color={iconColor}
            as={VisibilityOffIcon}
            onClick={() =>
              showNeverViewPromptModal({
                onSubmit: onHide,
                title: promptTitle,
                subtitle: promptSubtitle,
              })
            }
          />
        }
        overlayComponent={S.InfoDropdownOverlay}
        content={t('Components:neverViewButton.label')}
        placementX="center"
        placementY="top"
      />
    );
  },
);

NeverViewButton.displayName = 'NeverViewButton';
